import React, {useEffect, useState} from "react";
import {Button, Col, Modal, Row} from "react-bootstrap";
import {createPlateHistory} from "./ClientPlateQueries";
import {saveData} from "../../../helpers/Api";
import FlashMessage from "../../shared/FlashMessage";
import {BackButton} from "../../../helpers/ButtonHelper";
import {useMutation} from "@apollo/client";
import ReactStars from "react-rating-stars-component/dist/react-stars";

const PlateAteModal = ({
                         item,
                         onClose,
                         shouldOpen,
                         showButton,
                         refetch
                       }) => {
  const [show, setShow] = useState(false);
  const [flash, setFlash] = useState({});

  const closeModal = () => {
    setFlash({})
    setShow(false);
    if (onClose) onClose();
  }
  const showModal = (e) => {
    e.preventDefault()
    e.stopPropagation()
    setShow(true);
  }

  useEffect(() => {
    if (shouldOpen) {
      showModal(true)
    }
  }, [shouldOpen])

  const [saveCall] = useMutation(createPlateHistory)

  const onSubmit = (event, aaa) => {
    event.preventDefault()

    saveData({
      event: event,
      gqlCall: saveCall,
      query_key: 'createPlateHistory',
      flash_callback: setFlash,
      success: () => refetch()
    })
  }

  // const ratingChanged = (res) => {
  //   document.getElementById("rating").value = res
  // }

  return (
    <>
      {showButton && <Button variant="outline-primary" onClick={showModal}>Am Mancat</Button>}

      <Modal show={show} onHide={closeModal} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>{item.plate.name}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="mt-2 mb-4">
            <form onSubmit={onSubmit}>
              <div className='d-none'>
                <input type='hidden' name='id' defaultValue={item.id}/>
                <input type='hidden' name='action' defaultValue='ate'/>
              </div>
              <Row className='mb-3'>
                <Col>
                  <label htmlFor='image'>Imagine</label>
                  <input name='image' className="form-control" id="image" type='file'/>
                </Col>
              </Row>
              <Row className='mb-3'>
                <Col>
                  <label htmlFor='comment'>Lasa un comentariu (doar pentru nutritionist)</label>
                  <textarea name='comment' className="form-control" id="comment" rows='1'/>
                </Col>
              </Row>
              <Row className='mb-3'>
                <Col>
                  <input type='hidden' name='rating' id='rating'/>
                  <label htmlFor='comment' className='float-start me-3 mt-1'>Rating</label>
                  <ReactStars count={5} size={24} activeColor="#ffd700"
                              onChange={res => document.getElementById("rating").value = res}
                  />
                </Col>
              </Row>
              <Row className="mb-3">
                <FlashMessage flash={flash} buttons={
                  <>
                    <BackButton onClick={closeModal} to="#" className='float-end' showText={true} size='md'
                                text='Inchide'/>
                    <Button type='submit' className='float-end'>Am mancat</Button>
                  </>
                }/>
              </Row>
            </form>
          </div>
        </Modal.Body>
      </Modal>
    </>
  )
};

export default PlateAteModal;